import {
  Competition as SharedCompetition,
  CompAmplifier as SharedCompAmplifier,
  CompDenomination as SharedCompDenomination,
  CompField as SharedCompField,
  CompEntry as SharedCompEntry,
  CompFormat as SharedCompFormat,
  CompHandicap as SharedCompHandicap,
  CompHoleTies as SharedCompHoleTies,
  CompScoreAmplifier as SharedCompScoreAmplifier,
  CompScoringAmplifierCondition as SharedCompScoringAmplifierCondition,
  ScoreFilter as SharedScoreFilter,
  ScoreFilterType as SharedScoreFilterType,
  ScoreFilterBasis as SharedScoreFilterBasis,
  SCORE_FILTER_TYPES as SharedScoreFilterTypes,
  SCORE_FILTER_BASIS as SharedScoreFilterBases,
  CompScoring as SharedCompScoring,
  CompScoringMethod as SharedCompScoringMethod,
  CompAggregation as SharedCompAggregation,
  CompRankDirection as SharedCompRankDirection,
  CompHandicapValueType as SharedCompHandicapValueType,
  GroupCalc as SharedGroupCalc,
  CompPointsTablePreset as SharedCompPointsTablePreset,
  CompPointsTable as SharedCompPointsTable,
  CompStructure as SharedCompStructure,
  CompTiebreaker as SharedCompTiebreaker,
  GroupScoringConfig as SharedGroupScoringConfig,
  HoleGroupScore as SharedHoleGroupScore,
  IndexBracket as SharedIndexBracket,
  ExcludedPlayer as SharedExcludedPlayer,
  ScoreWindow as SharedScoreWindow,
  HoleMeasurementKey as SharedHoleMeasurementKey,
  HoleMeasurementConfig as SharedHoleMeasurementConfig,
  HOLE_MEASUREMENT_KEYS as SharedHoleMeasurementKeys,
  HOLE_MEASUREMENT_CONFIGS as SharedHoleMeasurementConfigs,
  COMP_DENOMINATIONS as SharedDenominations,
  COMP_FIELDS as SharedFields,
  COMP_ENTRIES as SharedEntries,
  COMP_FORMATS as SharedFormats,
  COMP_HANDICAPS as SharedHandicaps,
  COMP_HOLE_TIES as SharedHoleTies,
  COMP_SCORE_AMPLIFIERS as SharedScoreAmplifiers,
  COMP_SCORE_AMPLIFIER_CONDITIONS as SharedScoreAmplifierConditions,
  COMP_SCORINGS as SharedScorings,
  COMP_SCORING_METHODS as SharedScoringMethods,
  COMP_AGGREGATIONS as SharedAggregations,
  COMP_RANK_DIRECTIONS as SharedRankDirections,
  COMP_HANDICAP_VALUE_TYPES as SharedHandicapValueTypes,
  GROUP_CALCS as SharedGroupCalcs,
  COMP_POINTS_TABLES as SharedPointsTables,
  COMP_STRUCTURES as SharedStructures,
  COMP_TIEBREAKERS as SharedTiebreakers,
  STABLEFORD_STANDARD as SharedStablefordStandard,
  STABLEFORD_MODIFIED as SharedStablefordModified,
  CompNetHandicapBasis as SharedCompNetHandicapBasis,
  COMP_NET_HANDICAP_BASIS as SharedNetHandicapBasis,
  CompHoleCapType as SharedCompHoleCapType,
  COMP_HOLE_CAP_TYPES as SharedHoleCapTypes,
  SCORECARD_EXTRA_ROW_TYPES as SharedScorecardExtraRowTypes,
  ScorecardExtraRowType as SharedScorecardExtraRowType,
  ScorecardExtraRow as SharedScorecardExtraRow,
  ScorecardConfig as SharedScorecardConfig,
  ONE_SCORE_FORMATS as SharedOneScoreFormats,
  HandicapAllowanceDefault as SharedHandicapAllowanceDefault,
  DEFAULT_HANDICAP_ALLOWANCE as SharedDefaultHandicapAllowance,
  ScoringUnitShape as SharedScoringUnitShape,
  MatchTotalBasis as SharedMatchTotalBasis,
  MatchOutcomeScores as SharedMatchOutcomeScores,
  MATCH_TOTAL_BASES as SharedMatchTotalBases,
  DEFAULT_MATCH_HOLE_SCORES as SharedDefaultMatchHoleScores,
  DEFAULT_MATCH_GAME_SCORES as SharedDefaultMatchGameScores,
  ActivePerHole as SharedActivePerHole,
  ActiveRotation as SharedActiveRotation,
  ACTIVE_ROTATIONS as SharedActiveRotations,
  ALL_ACTIVE_ROTATIONS as SharedAllActiveRotations,
  DEFAULT_ACTIVE_ROTATION as SharedDefaultActiveRotation,
} from "shared/dist/types/Competition";
import {
  CompetitionPreset as SharedCompetitionPreset,
  COMPETITION_PRESETS as SharedCompetitionPresets,
  inferCompetitionParams as sharedInferCompetitionParams,
} from "shared/dist/types/CompetitionPreset";

export type CompAmplifier = SharedCompAmplifier;
export type CompDenomination = SharedCompDenomination;
export type CompField = SharedCompField;
export type CompEntry = SharedCompEntry;
export type CompFormat = SharedCompFormat;
export type CompHandicap = SharedCompHandicap;
export type CompHoleTies = SharedCompHoleTies;
export type CompScoreAmplifier = SharedCompScoreAmplifier;
export type CompScoringAmplifierCondition = SharedCompScoringAmplifierCondition;
export type ScoreFilter = SharedScoreFilter;
export type ScoreFilterType = SharedScoreFilterType;
export type ScoreFilterBasis = SharedScoreFilterBasis;
export type CompScoring = SharedCompScoring;
export type CompScoringMethod = SharedCompScoringMethod;
export type CompAggregation = SharedCompAggregation;
export type CompRankDirection = SharedCompRankDirection;
export type CompHandicapValueType = SharedCompHandicapValueType;
export type GroupCalc = SharedGroupCalc;
export type CompPointsTablePreset = SharedCompPointsTablePreset;
export type CompPointsTable = SharedCompPointsTable;
export type CompStructure = SharedCompStructure;
export type CompTiebreaker = SharedCompTiebreaker;
export type GroupScoringConfig = SharedGroupScoringConfig;
export type HoleGroupScore = SharedHoleGroupScore;
export type IndexBracket = SharedIndexBracket;
export type ExcludedPlayer = SharedExcludedPlayer;
export type ScoreWindow = SharedScoreWindow;
export type HoleMeasurementKey = SharedHoleMeasurementKey;
export type HoleMeasurementConfig = SharedHoleMeasurementConfig;
export type HandicapAllowanceDefault = SharedHandicapAllowanceDefault;
export type ScoringUnitShape = SharedScoringUnitShape;
export type MatchTotalBasis = SharedMatchTotalBasis;
export type MatchOutcomeScores = SharedMatchOutcomeScores;
export type ActivePerHole = SharedActivePerHole;
export type ActiveRotation = SharedActiveRotation;

export const HOLE_MEASUREMENT_KEYS = SharedHoleMeasurementKeys;
export const HOLE_MEASUREMENT_CONFIGS = SharedHoleMeasurementConfigs;

export const SCORE_FILTER_TYPES = SharedScoreFilterTypes;
export const SCORE_FILTER_BASIS = SharedScoreFilterBases;
export const COMP_DENOMINATIONS = SharedDenominations;
export const COMP_FIELDS = SharedFields;
export const COMP_ENTRIES = SharedEntries;
export const COMP_FORMATS = SharedFormats;
export const COMP_HANDICAPS = SharedHandicaps;
export const COMP_HOLE_TIES = SharedHoleTies;
export const COMP_SCORE_AMPLIFIERS = SharedScoreAmplifiers;
export const COMP_SCORE_AMPLIFIER_CONDITIONS = SharedScoreAmplifierConditions;
export const COMP_SCORINGS = SharedScorings;
export const COMP_SCORING_METHODS = SharedScoringMethods;
export const COMP_AGGREGATIONS = SharedAggregations;
export const COMP_RANK_DIRECTIONS = SharedRankDirections;
export const COMP_HANDICAP_VALUE_TYPES = SharedHandicapValueTypes;
export const GROUP_CALCS = SharedGroupCalcs;
export const COMP_POINTS_TABLES = SharedPointsTables;
export const COMP_STRUCTURES = SharedStructures;
export const COMP_TIEBREAKERS = SharedTiebreakers;
export const ONE_SCORE_FORMATS = SharedOneScoreFormats;
export const DEFAULT_HANDICAP_ALLOWANCE = SharedDefaultHandicapAllowance;
export const MATCH_TOTAL_BASES = SharedMatchTotalBases;
export const DEFAULT_MATCH_HOLE_SCORES = SharedDefaultMatchHoleScores;
export const DEFAULT_MATCH_GAME_SCORES = SharedDefaultMatchGameScores;
export const ACTIVE_ROTATIONS = SharedActiveRotations;
export const ALL_ACTIVE_ROTATIONS = SharedAllActiveRotations;
export const DEFAULT_ACTIVE_ROTATION = SharedDefaultActiveRotation;
export const COMP_NET_HANDICAP_BASIS = SharedNetHandicapBasis;
export const COMP_HOLE_CAP_TYPES = SharedHoleCapTypes;
export const STABLEFORD_STANDARD = SharedStablefordStandard;
export const STABLEFORD_MODIFIED = SharedStablefordModified;

export type CompNetHandicapBasis = SharedCompNetHandicapBasis;
export type CompHoleCapType = SharedCompHoleCapType;
export type ScorecardExtraRowType = SharedScorecardExtraRowType;
export type ScorecardExtraRow = SharedScorecardExtraRow;
export type ScorecardConfig = SharedScorecardConfig;
export const SCORECARD_EXTRA_ROW_TYPES = SharedScorecardExtraRowTypes;

export type CompetitionPreset = SharedCompetitionPreset;
export const COMPETITION_PRESETS = SharedCompetitionPresets;
export const inferCompetitionParams = sharedInferCompetitionParams;

export default interface Competition extends SharedCompetition {}
